<template>
  <div class="w-full flex justify-center">
    <ul class="pagination" v-if="pager.pages && pager.pages.length">
      <li class="page-item first" :class="{'disabled': pager.currentPage === 1}">
        <a class="page-link" @click="pager.currentPage === 1 ? null : setPage(1)">{{labels.first}}</a>
      </li>
      <li class="page-item previous" :class="{'disabled': pager.currentPage === 1}">
        <a class="page-link" @click="pager.currentPage === 1 ? null : setPage(pager.currentPage - 1)">{{labels.previous}}</a>
      </li>
      <li v-for="page in pager.pages" :key="page" class="page-item page-number" :class="{'active': pager.currentPage === page}">
        <a class="page-link" @click="pager.currentPage === page ? null : setPage(page)">{{page}}</a>
      </li>
      <li class="page-item next" :class="{'disabled': pager.currentPage === pager.totalPages}">
        <a class="page-link" @click="pager.currentPage === pager.totalPages ? null : setPage(pager.currentPage + 1)">{{labels.next}}</a>
      </li>
      <li class="page-item last" :class="{'disabled': pager.currentPage === pager.totalPages}">
        <a class="page-link" @click="pager.currentPage === pager.totalPages ? null : setPage(pager.totalPages)">{{labels.last}}</a>
      </li>
    </ul>
  </div>
</template>
<script>
import paginate from 'jw-paginate'
export default {
  props: {
    items: {
      type: Number,
      required: true
    },
    initialPage: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 12
    },
    maxPages: {
      type: Number,
      default: 12
    },
    labels: {
      type: Object,
      default: () => {
        return {
          first: '<<',
          last: '>>',
          previous: '<',
          next: '>'
        }
      }
    }
  },
  data () {
    return {
      pager: {}
    }
  },
  created () {
    if (!this.$listeners.changePage) throw 'Missing required event listener: "changePage"'
  },
  watch: {
    items () {
      this.setPage(this.initialPage)
    },
    pageSize () {
      this.setPage(this.initialPage)
    }
  },
  methods: {
    setPage (page) {
      const { items, pageSize, maxPages } = this
      if (process.env.NODE_ENV === 'development') console.log(items, page, pageSize, maxPages)
      this.pager = paginate(items, page, pageSize, maxPages)
      this.$emit('changePage', this.pager)
    }
  }
}
</script>
<style lang="scss">
  .pagination {
    display: flex;
    flex-flow: row;
    justify-content: center;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 20px;
  }
  .pagination li {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    text-align: center;
  }
  .pagination li a {
    transition: all 0.25s ease;
    border-radius: 100%;
    min-width: 36px;
    line-height: 36px;
  }
  .pagination li.active a {
    cursor: default;
    color: #fff;
    background: #b41f26;
  }
</style>
